/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".account-details-container[_ngcontent-%COMP%], .current-bill-container[_ngcontent-%COMP%] {\n    background-color: white;\n    padding-left: 0rem;\n    padding-right: 0rem;\n}\n.overview-header-container[_ngcontent-%COMP%] {\n  padding-left: 0.1rem;\n}\n.current-bill-container[_ngcontent-%COMP%] {\n  width: 72%;\n}\n.overview-header[_ngcontent-%COMP%] {\n    color: #545454;\n    margin-bottom: 3rem;\n}\n.right-page-column[_ngcontent-%COMP%] {\n    margin-left: 2rem;\n}\n.row2[_ngcontent-%COMP%] {\n  margin-bottom: 4.5rem;\n}\n.row3[_ngcontent-%COMP%] {\n  margin-bottom: 5rem;\n}\n.banner-row[_ngcontent-%COMP%] {\n  height: 7rem;\n  background-color: #fff !important;\n}\n.top-margin-row[_ngcontent-%COMP%] {\n  height: 3rem;\n  background-color: #f5f5f5;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/page/page.component.css.shim.ngstyle.js.pre-build-optimizer.js